module.exports = __webpack_public_path__ + "static/media/Ticketing-Table-for-1.964898d5.svg";